export enum Routes {
  home = '/',
  selectImage = '/select-image',
  upload= '/upload',
  preview= '/preview',
}
